module.exports = __webpack_public_path__ + "static/img/dot-hit.fa32ede.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/four/dot-hit.png
// module id = xBku
// module chunks = 1